import React, {useState} from 'react'
import {Swiper, SwiperSlide, useSwiper} from 'swiper/react'
import {Grid, Navigation, Pagination} from 'swiper'
import 'swiper/css/pagination'
import 'swiper/css/grid'
import Balancer from 'react-wrap-balancer'
import './personal.css'

import people1 from '../../../../images/main/people_1.jpg'
import people2 from '../../../../images/main/people_2.png'
import people3 from '../../../../images/main/people_3.png'
import people4 from '../../../../images/main/people_4.jpg'
// import people5 from '../../../../images/main/people_5.jpg'
import styles from './styles.module.scss'

const PersonalGenerium = () => {
  const [swiper, setSwiper] = useState(null);
  const [indexSwiperElem, setIndexSwiperElem] = useState(0)

  return (
    <div className={styles.wrapper}>
      <div className={styles.wr1}>
        <div className={styles.left}>
          <div>
            <p className={styles.title}>Честные отзывы</p>
          </div>
        </div>
        <div className={styles.right}>
          <div className='flex flex-col'>
            <p className={styles.title}>Сотрудники о Generium</p>
          </div>
        </div>
      </div>
      <div className={styles.wr2}>
        <div className={styles.left}>
          <div className={styles.preview_people}>
            {indexSwiperElem !== 0 ? (
              <>
                <div onClick={() => swiper.slideTo(0)}>
                  <img className='preview_people-slider-photo' src={people2} alt='people' draggable='false'/>
                </div>
              </>
            ) : ''}
            {indexSwiperElem !== 1 ? (
              <>
                <div onClick={() => swiper.slideTo(1)}>
                  <img className='preview_people-slider-photo' src={people3} alt='people' draggable='false'/>
                </div>
              </>
            ) : ''}
            {indexSwiperElem !== 2 ? (
              <>
                <div onClick={() => swiper.slideTo(2)}>
                  <img className='preview_people-slider-photo' src={people4} alt='people' draggable='false'/>
                </div>
              </>
            ) : ''}
            {/* {indexSwiperElem !== 3 ? (
              <>
                <div onClick={() => swiper.slideTo(3)}>
                  <img className='preview_people-slider-photo' src={people5} alt='people' draggable='false'/>
                </div>
              </>
            ) : ''} */}
            {indexSwiperElem !== 3 ? (
              <>
                <div onClick={() => swiper.slideTo(4)}>
                  <img className='preview_people-slider-photo' src={people1} alt='people' draggable='false'/>
                </div>
              </>
            ) : ''}
          </div>
          <div className={styles.preview_people_active}>
            {indexSwiperElem == 0 ? (
              <><img className='preview_people_active-slider-photo' src={people2} alt='people' draggable='false'/></>
            ) : ''}
            {indexSwiperElem == 1 ? (
              <><img className='preview_people_active-slider-photo' src={people3} alt='people' draggable='false'/></>
            ) : ''}
            {indexSwiperElem == 2 ? (
              <><img className='preview_people_active-slider-photo' src={people4} alt='people' draggable='false'/></>
            ) : ''}
            {/* {indexSwiperElem == 3 ? (
              <><img className='preview_people_active-slider-photo' src={people5} alt='people' draggable='false'/></>
            ) : ''} */}
            {indexSwiperElem == 3 ? (
              <><img className='preview_people_active-slider-photo' src={people1} alt='people' draggable='false'/></>
            ) : ''}
          </div>
        </div>
        <div className={styles.right}>
          <p className={styles.text2}>
            <Balancer ratio={0.50}>
              {indexSwiperElem === 0
                ? 'Мой путь в Generium начался с должности технолога, затем меня повысили до старшего технолога, а сейчас я доросла до начальника участка биосинтеза.'
                + '\n\n' +
                'Расти в компании мне помогло желание сделать цех лучше — принести от себя что-то новое, оставить след. На любой должности я старалась выполнять идеально все обязанности и в тоже время искала новую информацию, чтобы быть на шаг впереди. А компания помогала мне в этом, компенсируя затраты на обучение и предоставляя доступ к научной литературе.'

                : indexSwiperElem === 1
                  ? 'Когда я пришел в Generium, было несколько разрозненных лабораторий в Москве. Только через полтора года эти лаборатории объединились в Вольгинском в один большой институт.'
                  + '\n\n' +
                  'Больше всего мне нравится, что компания вместе с сотрудниками постоянно растет, развивается, ставит новые цели и достигает их. Я часто пытаюсь проанализировать свой карьерный рост и понимаю, что здесь сошлось вместе много факторов. Среди них — высокая вовлеченность в рабочий процесс, способность добиваться результата в сжатые сроки и, конечно же, немного удачи.'

                  : indexSwiperElem === 2
                    ? 'В начале 2016 года я пришел на работу в Generium. В то время компания находилась в процессе своего становления, но уже был понятен потенциал, заложенный ее основателями и руководителями. Мне всегда хотелось работать именно в такой серьезной компании, которая ставит перед собой глобальные цели. Именно масштабные цели являются для меня привлекательными и стали первоочередной причиной трудоустройства.'
                    + '\n\n' +
                    'Работая в Generium, я прошел несколько карьерных этапов, и на каждом из них меня поджидали свои вызовы, которые мы успешно преодолевали всей командой. С 2016 года я проработал в отделе трансфера технологий и на экспериментальном производстве, наладил производственные процессы, вывел продукт на клинические исследования и занимался крупнотоннажным запуском производства вакцины. Разнообразие целей и задач в Generium меня заряжает. Здорово быть частью такой глобальной команды!'

                    // : indexSwiperElem === 3
                    //   ? 'Компания Generium довольно молодая для отрасли, существует всего 12 лет, но уже многого добилась и ставит перед собой серьезные задачи в области лечения редких заболеваний.'
                    //   + '\n\n' +
                    //   'Компания дает возможность сотрудникам развиваться, ставить перед собой цели и достигать их. Работа в команде единомышленников и просто талантливых людей стимулирует на реализацию новых проектов.'
                    //   + '\n\n' +
                    //   'То, что мы помогаем пациентам, которые страдают редким заболеваниями, делает нашу миссию особенной, одухотворенной и вдохновляет нас.'

                      : indexSwiperElem === 3
                        ? 'Компания Generium – это семья, молодая и дружная, со своими амбициями и достижениями, с кипящей социальной жизнью, в которой, тем не менее, всегда найдется место для комфорта и спокойной, сосредоточенной работы. Здесь любой сможет реализовать себя как профессионал, раскрыв свой потенциал на максимум. Здесь хорошо, здесь интересно, здесь тебя ценят. Join us :) '
                        + '\n\n' +
                        'Для сотрудника, ранее не работавшего в подобных компаниях, Generium открывает двери в удивительный, интересный мир фармацевтической индустрии. Человек, имеющий руки и голову, способный обучаться, обладающий рабочей этикой и дисциплиной, безусловно, найдет здесь свой путь к успеху и сможет достичь в компании многого.'

                        : 'Мой путь в Generium начался с должности технолога, затем меня повысили до старшего технолога, а сейчас доросла до начальника участка биосинтеза.'
                        + '\n\n' +
                        'Расти в компании мне помогло желание сделать цех лучше — принести от себя что-то новое, оставить след. На любой должности я старалась выполнять идеально все обязанности и в тоже время искала новую информацию, чтобы быть «на шаг впереди». А компания помогала мне в этом, компенсируя затраты на обучение и предоставляя доступ к научной литературе.'}
            </Balancer>
          </p>
          <div className="slider_main_mod_pg">
            <Swiper
              spaceBetween={70}
              slidesPerView={1}
              navigation
              onSlideChange={swiper => setIndexSwiperElem(swiper.activeIndex)}
              pagination={{
                type: 'fraction'
              }}
              onSwiper={setSwiper}
              modules={[Pagination, Navigation]}
              breakpoints={{
              // 1537: {
              //   spaceBetween: 70,
              //   slidesPerView: 1
              // },
              // 1536: {
              //   spaceBetween: 70,
              //   slidesPerView: 4
              // },
              // 1440: {
              //   spaceBetween: 70,
              //   slidesPerView: 3.9
              // },
              // 1365: {
              //   spaceBetween: 70,
              //   slidesPerView: 3.6
              // },
              // 1025: {
              //   spaceBetween: 55,
              //   slidesPerView: 3.2
              // },
              // 769: {
              //   spaceBetween: 50,
              //   slidesPerView: 3
              // },
              640: {
                slidesPerView: 1,
                initialSlide: 0
              },
              480: {
                spaceBetween: 16,
                initialSlide: 0,
                slideToClickedSlide: true
              },
              370: {
                spaceBetween: 16,
                initialSlide: 0,
                slideToClickedSlide: true
              },
              320: {
                spaceBetween: 16,
                initialSlide: 0,
                slideToClickedSlide: true
              }
               }}
            >
              <SwiperSlide id='0' className='wrapper-item-slider-people'>
                <div>
                  <div className={styles.img}>
                    <img className='people-slider-photo' src={people2} alt='people' draggable='false'/>
                  </div>
                  <div className={styles.desc}>
                    <p className={styles.text}>Мой путь в Generium начался с должности технолога, затем меня повысили до старшего технолога, а сейчас я доросла до начальника участка биосинтеза.</p>
                    <p className={styles.text}>Расти в компании мне помогло желание сделать цех лучше — принести от себя что-то новое, оставить след. На любой должности я старалась выполнять идеально все обязанности и в тоже время искала новую информацию, чтобы быть на шаг впереди. А компания помогала мне в этом, компенсируя затраты на обучение и предоставляя доступ к научной литературе.</p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide id='1' className='wrapper-item-slider-people'>
                <div>
                  <div className={styles.img}>
                    <img className='people-slider-photo' src={people3} alt='people' draggable='false'/>
                  </div>
                  <div className={styles.desc}>
                    <p className={styles.text}>Когда я пришел в Generium, было несколько разрозненных лабораторий в Москве. Только через полтора года эти лаборатории объединились в Вольгинском в один большой институт.</p>
                    <p className={styles.text}>Больше всего мне нравится, что компания вместе с сотрудниками постоянно растет, развивается, ставит новые цели и достигает их. Я часто пытаюсь проанализировать свой карьерный рост и понимаю, что здесь сошлось вместе много факторов. Среди них — высокая вовлеченность в рабочий процесс, способность добиваться результата в сжатые сроки и, конечно же, немного удачи.</p>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide id='2' className='wrapper-item-slider-people'>
                <div>
                  <div className={styles.img}>
                    <img className='people-slider-photo' src={people4} alt='people' draggable='false'/>
                  </div>
                  <div className={styles.desc}>
                    <p className={styles.text}>В начале 2016 года я пришел на работу в Generium. В то время компания находилась в процессе своего становления, но уже был понятен потенциал, заложенный ее основателями и руководителями. Мне всегда хотелось работать именно в такой серьезной компании, которая ставит перед собой глобальные цели. Именно масштабные цели являются для меня привлекательными и стали первоочередной причиной трудоустройства.</p>
                    <p className={styles.text}>Работая в Generium, я прошел несколько карьерных этапов, и на каждом из них меня поджидали свои вызовы, которые мы успешно преодолевали всей командой. С 2016 года я проработал в отделе трансфера технологий и на экспериментальном производстве, наладил производственные процессы, вывел продукт на клинические исследования и занимался крупнотоннажным запуском производства вакцины. Разнообразие целей и задач в Generium меня заряжает. Здорово быть частью такой глобальной команды!</p>
                  </div>
                </div>
              </SwiperSlide>

              {/* <SwiperSlide id='3' className='wrapper-item-slider-people'>
                <div>
                  <div className={styles.img}>
                    <img className='people-slider-photo' src={people5} alt='people' draggable='false'/>
                  </div>
                  <div className={styles.desc}>
                    <p className={styles.text}>Компания Generium довольно молодая для отрасли, существует всего 12 лет, но уже многого добилась и ставит перед собой серьезные задачи в области лечения редких заболеваний.</p>
                    <p className={styles.text}>Компания дает возможность сотрудникам развиваться, ставить перед собой цели и достигать их. Работа в команде единомышленников и просто талантливых людей стимулирует на реализацию новых проектов.</p>
                    <p className={styles.text}>То, что мы помогаем пациентам, которые страдают редким заболеваниями, делает нашу миссию особенной, одухотворенной и вдохновляет нас.</p>
                  </div>
                </div>
              </SwiperSlide> */}

              <SwiperSlide id='3' className='wrapper-item-slider-people'>
                <div>
                  <div className={styles.img}>
                    <img className='people-slider-photo' src={people1} alt='people' draggable='false'/>
                  </div>
                  <div className={styles.desc}>
                    <p className={styles.text}>Компания Generium – это семья, молодая и дружная, со своими амбициями и достижениями, с кипящей социальной жизнью, в которой, тем не менее, всегда найдется место для комфорта и спокойной, сосредоточенной работы. Здесь любой сможет реализовать себя как профессионал, раскрыв свой потенциал на максимум. Здесь хорошо, здесь интересно, здесь тебя ценят. Join us :)</p>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
          <p className={styles.text_b}>
            {indexSwiperElem === 0 ? (
              <>
                <p>Яна</p>
                <p>Начальник участка цеха</p>
              </>
            ) : indexSwiperElem === 1 ? (
              <>
                <p>Антон</p>
                <p>Директор департамента</p>
              </>
            ) : indexSwiperElem === 2 ? (
              <>
                <p>Николай</p>
                <p>Директор департамента</p>
              </>
            ) : indexSwiperElem === 3 ? (
              <>
                <p>Всеволод</p>
                <p>Начальник отдела</p>
              </>
            ) : (
              <>
                <p>Яна Слащинина,</p>
                <p>начальник участка цеха по производству биологически активных веществ</p>
              </>
            )}

            {/*
              : indexSwiperElem === 3 ? (
              <>
                <p>Екатерина</p>
                <p>Ведущий проектный менеджер</p>
              </>
              )
              */}
          </p>
        </div>
      </div>
    </div>
  )
}

export default PersonalGenerium
